import { createClient } from '@supabase/supabase-js'
import { SUPABASE_URL, SUPABASE_ANON_KEY } from '@/env'
import type { Database } from '@/lib/database.types'

// Use a non-empty placeholder URL when env isn't configured yet, so the app
// still renders (blank-page prevention) instead of createClient throwing at
// import time. Auth/data calls will then fail gracefully until a real
// project is wired up via .env.
const HAS_BACKEND = Boolean(SUPABASE_URL && SUPABASE_ANON_KEY)
export const isBackendConfigured = HAS_BACKEND

export const supabase = createClient<Database>(
  SUPABASE_URL || 'https://placeholder.supabase.co',
  SUPABASE_ANON_KEY || 'placeholder-anon-key',
  {
    auth: {
      persistSession: true,
      autoRefreshToken: HAS_BACKEND,
      detectSessionInUrl: HAS_BACKEND,
    },
  },
)